import { Typography, styled } from '@mui/material';
import { TableCell } from 'further-ui/components/Table';
import getPeriodLabel from './get-period-label';
import type { PcapPeriodResult } from './types';

const PeriodHeaderBottomCell = styled(TableCell)(({ theme }) => ({
  borderTop: 'none',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  borderLeft: 'none',
  borderRight: 'none',
  verticalAlign: 'bottom',
  paddingBottom: theme.spacing(4),
}));

type Props = {
  title: string;
  period: PcapPeriodResult;
};

export default function PeriodHeaderCell({ title, period }: Props) {
  return (
    <PeriodHeaderBottomCell isHeaderCell size="small">
      <Typography variant="inherit" color="grey.500" display="block">
        {title}
      </Typography>
      <Typography variant="inherit" color="grey.500" display="block">
        {getPeriodLabel(period)}
      </Typography>
    </PeriodHeaderBottomCell>
  );
}
